<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('routes.Brands') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent  @click="openFilterDialog" svg="4"
                    class="mr-4"
                    />
                    <genericBtnComponent  :ClickFun="navigateToNewBrand" svg="2"
                    :Title="$t('Brands.create')" />
            </div>
            
        </div>
        <v-card elevation="0">
            <BrandsList  :showFilterDialog="showFilterDialog" @open-filter-dialog="openFilterDialog"/>
        </v-card>
    </div>
</template>
<script>
import { isClient } from "@/api/index";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import BrandsList from "@/components/Brands/BrandsList.vue";
export default {
    components: {
        genericBtnComponent,
        BrandsList,
    },
    data() {
        return {
            showFilterDialog : false

        }
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.purchasesOrder');
    },
    methods: {
        openFilterDialog(newValue){
            this.showFilterDialog = newValue;
        },
        closeFilterDialog() {
            this.showFilterDialog = false;
        },
        navigateToNewBrand() {
            this.$router.push({ path: '/NewBrand' });
        },
        isClient() {
            return isClient()
        }
    }
};

</script>
